import axios from "axios";

// let BASEURL = 'https://devdemo.shrigenesis.com/creators_hub/backend/';
// let BASEURL = 'https://creatorhub.paradiselkf.com/backend/';
let BASEURL = "https://creatorhub.moneykart.in/backend/";
let BRAND = "brandApi";
let INFLUNCER = "influencerApi";
let COMMON = "common";

export const ApiUrl = {
  // common
  contactUs: `${BASEURL}${COMMON}/contact-form`,
  collaborationHub: `${BASEURL}${COMMON}/collaboration-hub`,
  collaborationHubFilter: `${BASEURL}${COMMON}/collaboration-hub/filter`,
  collaborationHubFilterName: `${BASEURL}${COMMON}/collaboration-hub/filter-name`,
  getWorkPlatforms: `${BASEURL}${COMMON}/work-platforms`,
  // Brands
  createCampaign: `${BASEURL}${BRAND}/createCampaign`,
  myCampaign: `${BASEURL}${BRAND}/myCampaigns`,
  deleteMyCampaign: `${BASEURL}${BRAND}/deleteCampaign`,
  newCampaign: `${BASEURL}${BRAND}/updateCampaign`,
  validateLoginInfo: `${BASEURL}${BRAND}/validateLoginInfo`,
  validateBrandInfo: `${BASEURL}${BRAND}/validateBrandInfo`,
  signUp: `${BASEURL}${BRAND}/signUp`,
  brandLogin: `${BASEURL}${BRAND}/login`,
  brandLogout: `${BASEURL}${BRAND}/logout`,
  uploadLogo: `${BASEURL}${BRAND}/upload`,
  brandSocialLogin: `${BASEURL}${BRAND}/brandSocialLogin`,
  getCampaignCreationData: `${BASEURL}${BRAND}/getAddCampaignData`,
  getCampaignTasks: `${BASEURL}${BRAND}/getCampaignTasks`,
  addCampaign: `${BASEURL}${BRAND}/addCampaign`,
  getBrandCampaigns: `${BASEURL}${BRAND}/getBrandCampaigns`,
  updateCampaignTaskRequest: `${BASEURL}${BRAND}/updateCampaignTaskRequest`,
  brandFetchPostTrackingData: `${BASEURL}${BRAND}/brandFetchPostTrackingData`,
  forgotPassword: `${BASEURL}${BRAND}/forgot-password`,
  resetPassword: `${BASEURL}${BRAND}/reset-password`,
  brandMarkFavorite: `${BASEURL}${BRAND}/markFavorite`,
  getInfluencersToInvite: `${BASEURL}${BRAND}/getInfluencersToInvite`,
  inviteInfluencers: `${BASEURL}${BRAND}/inviteInfluencers`,
  getBrandProfile: `${BASEURL}${BRAND}/profile`,
  updateBrandProfile: `${BASEURL}${BRAND}/updateProfile`,
  brandWalletTransactions: `${BASEURL}${BRAND}/walletTransactions`,
  brandGetWalletBalance: `${BASEURL}${BRAND}/getWalletBalance`,
  getAllCampaignTasks: `${BASEURL}${BRAND}/allCampaignTasks`,
  // Influncer
  campaignStatus: `${BASEURL}${INFLUNCER}/campaign-task-status`,
  createPhylloAccount: `${BASEURL}${INFLUNCER}/phyllo/connect`,
  disConnectPhylloAccount: `${BASEURL}${INFLUNCER}/phyllo/accounts/disconnect`,
  getPhylloSocialAccounts: `${BASEURL}${INFLUNCER}/phyllo/accounts`,
  getSocialAccountsSync: `${BASEURL}${INFLUNCER}/phyllo/accounts/sync`,
  getSocialAccountsDetails: `${BASEURL}${INFLUNCER}/phyllo/profile`,
  validateLoginInfoInfulencer: `${BASEURL}${INFLUNCER}/validateLoginInfo`,
  countries: `${BASEURL}${INFLUNCER}/getCountries`,
  loginInfulencer: `${BASEURL}${INFLUNCER}/login`,
  infulencerLogout: `${BASEURL}${INFLUNCER}/logout`,
  accountDelete: `${BASEURL}${INFLUNCER}/delete`,
  addToWishlist: `${BASEURL}${INFLUNCER}/wishlist/add`,
  removeFromWishlist: `${BASEURL}${INFLUNCER}/wishlist/remove`,
  getWishlist: `${BASEURL}${INFLUNCER}/wishlist`,
  influencerSocialLogin: `${BASEURL}${INFLUNCER}/influencerSocialLogin`,
  infulencerValidateBasicData: `${BASEURL}${INFLUNCER}/validateBasicData`,
  getInfluencer: `${BASEURL}${INFLUNCER}/getInfluencer`,
  completeSignUp: `${BASEURL}${INFLUNCER}/completeSignUp`,
  getFacebookPages: `${BASEURL}${INFLUNCER}/getFacebookPages`,
  signUpViaFacebookAuth: `${BASEURL}${INFLUNCER}/signUpViaFacebookAuth`,
  registerInfluncerViaSoicalPlatform: `${BASEURL}${INFLUNCER}/registerInfluncerViaSoicalPlatform`,
  uploadFile: `${BASEURL}${INFLUNCER}/uploadFile`,
  applyCampagin: `${BASEURL}${INFLUNCER}/apply-for-campaign`,
  updateCampaign: `${BASEURL}${INFLUNCER}/update-campaign-request`,
  getCamapigns: `${BASEURL}${INFLUNCER}/campaigns`,
  optInCamapign: `${BASEURL}${INFLUNCER}/campaigns/opt-in`,
  getCamapignsByFilter: `${BASEURL}${INFLUNCER}/campaigns/filter`,
  getMyCampaignTasksRequests: `${BASEURL}${INFLUNCER}/getMyCampaignTasksRequests`,
  getCampaignTasksDetails: `${BASEURL}${INFLUNCER}/getCampaignRequestDetails`,
  updatedCampaignStatus: `${BASEURL}${INFLUNCER}/updatedCampaignStatus`,
  getMyPosts: `${BASEURL}${INFLUNCER}/myPosts`,
  getMyPayouts: `${BASEURL}${INFLUNCER}/postPayouts`,
  fetchPostTrackingData: `${BASEURL}${INFLUNCER}/fetchPostTrackingData`,
  withdrawalRequest: `${BASEURL}${INFLUNCER}/withdrawalRequest`,
  markFavorite: `${BASEURL}${INFLUNCER}/markFavorite`,
  forgotPasswordInfulencer: `${BASEURL}${INFLUNCER}/forgot-password`,
  resetPasswordInfulencer: `${BASEURL}${INFLUNCER}/reset-password`,
  getInfluncerProfile: `${BASEURL}${INFLUNCER}/profile`,
  updateInfluncerProfile: `${BASEURL}${INFLUNCER}/updateProfile`,
  influencerWalletTransactions: `${BASEURL}${INFLUNCER}/walletTransactions`,
  influencerGetWalletBalance: `${BASEURL}${INFLUNCER}/getWalletBalance`,
};

export const authHeaders = {
  Authorization: `Bearer ${localStorage.getItem("token")}`,
};
export const APIRequest = async (config = {}, onSuccess, onError) => {
  const token = localStorage.getItem("token")
    ? localStorage.getItem("token")
    : "";
  let data = {
    method: config.method,
    url: config.url,
    data: config.body,
    // headers: {
    //   Accept: 'application/json',
    //   'Content-Type': 'application/json',
    // },
  };
  if (token != "") {
    data = {
      method: config.method,
      url: config.url,
      data: config.body,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
  }
  try {
    axios(data)
      .then((res) => {
        if (res?.status === 200 || res?.status === 201) {
          onSuccess(res.data);
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          localStorage.clear();
        }
        onError(err);
      });
  } catch (error) {
    console.log("error", error);
  }
};
